// extracted by mini-css-extract-plugin
export default {"quiz_question":"ZZ","question_subheader":"a-","why_popup":"b-","why_underline":"c-","MyClassEnterDone":"e-","WhyAskEnterDone":"f-","WhyUnderlineEnterDone":"g-","main_question":"h-"};
    if(module.hot) {
      // 1713809679680
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  